<!-- desktop page starts -->
<div class="">
  <div class="website-container">
    <ng-container *ngTemplateOutlet="websiteContentTemplate;"></ng-container>
  </div>
</div>
<!-- desktop page ends -->


<!-- website content -->
<ng-template #websiteContentTemplate>
  <div class="c-margin-bottom">
    <lib-b2b-menu-card [containers]="layoutData?.menuContainer">
      <ng-container formComp>
        @if (layoutData; ) {
          @for (container of layoutData?.headerContainer; track container) {
            <div class="search-wrap">
              @switch (container?.component) {
                @case ('DesktopShortStaySearchFormComponent') {
                  <app-b2b-shortstay-form [compData]="{
                      container: container
                    }">
                  </app-b2b-shortstay-form>
                }
                @default {
                  @if (((container?.component | b2bDynamicLoaderPipe) | async); as component; ) {
                    <ng-container *ngComponentOutlet="component; inputs: {
                  compData: {
                      container: container
                  }
                }"/>
                  }
                }
              }
            </div>
          }
        }
      </ng-container>
    </lib-b2b-menu-card>
  </div>
  @if (layoutData; ) {
    @for (container of layoutData?.mainContainer; track container; let index = $index) {
      <div
        id="{{ container?.key }}"
        [style]="{
        'min-height': container?.sliderMinHeight + 'px',
        'display': container?.hidden ? 'none': 'block'
        }"
        class="c-margin-bottom"
      >
        @if (!container?.hidden) {
          <div
            appIntersectionObserver [intersectionDebounce]="0"
            [style]="{ 'min-height': container?.sliderMinHeight + 'px'}"
            (visibilityChange)="onVisibilityChanged(index, $event)"
          >
            @switch (visibilityStatus[index]) {
              @case (intersectionStatus.Visible) {
                @switch (container?.component) {

                  @case ('SliderComponent') {
                    <app-b2b-sliders
                      [compData]="{ container: container }"
                    >
                    </app-b2b-sliders>
                  }
                  @case ('DesktopLoginPopoverComponent') {
                    <app-b2b-login-pop-over
                      [compData]="{ container: container }"
                    >
                    </app-b2b-login-pop-over>
                  }
                  @default {
                    @if (((container?.component | b2bDynamicLoaderPipe) | async); as component; ) {
                      <div
                        class=""
                        id="{{ container?.key }}"
                      >
                        <ng-container *ngComponentOutlet="component; inputs: {
                        compData: {
                            container: container
                        }
                      }"/>
                      </div>
                    }
                  }
                }
              }
            }
          </div>
        }
        @if (!isServer && container?.hidden) {
          @if (((container?.component | b2bDynamicLoaderPipe) | async); as component; ) {
            <div
              class=""
              id="{{ container?.key }}"
            >
              <ng-container *ngComponentOutlet="component; inputs: {
                        compData: {
                            container: container
                        }
                      }"/>
            </div>
          }
        }
      </div>
    }
  }
</ng-template>
